import { render, staticRenderFns } from "./ProductDimensionsWeight.vue?vue&type=template&id=50200c2c&"
import script from "./ProductDimensionsWeight.vue?vue&type=script&lang=ts&"
export * from "./ProductDimensionsWeight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports